export default __webpack_public_path__ + "static/media/nomspace.1a2884f8.jpg";